var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0427 16.5C19.7296 16.5 20.2759 16.0678 20.7665 15.4634C21.7706 14.2262 20.1219 13.2374 19.4931 12.7532C18.8539 12.261 18.1402 11.9821 17.4165 11.9167M16.4999 10.0833C17.7655 10.0833 18.7915 9.05732 18.7915 7.79167C18.7915 6.52601 17.7655 5.5 16.4999 5.5",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95709 16.5C2.27023 16.5 1.7239 16.0678 1.23338 15.4634C0.229207 14.2262 1.87791 13.2374 2.50672 12.7532C3.14594 12.261 3.85966 11.9821 4.58329 11.9167M5.04163 10.0833C3.77597 10.0833 2.74996 9.05732 2.74996 7.79167C2.74996 6.52601 3.77597 5.5 5.04163 5.5",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41005 13.8519C6.47342 14.4311 4.01763 15.6136 5.51337 17.0935C6.24403 17.8163 7.05779 18.3333 8.08089 18.3333H13.9189C14.942 18.3333 15.7558 17.8163 16.4864 17.0935C17.9822 15.6136 15.5264 14.4311 14.5897 13.8519C12.3934 12.4938 9.60643 12.4938 7.41005 13.8519Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2082 6.87502C14.2082 8.64693 12.7718 10.0834 10.9999 10.0834C9.22798 10.0834 7.79156 8.64693 7.79156 6.87502C7.79156 5.10311 9.22798 3.66669 10.9999 3.66669C12.7718 3.66669 14.2082 5.10311 14.2082 6.87502Z",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.ef7fa97e7009202cceadd8b10ae63d42.svg";
export { ForwardRef as ReactComponent };